export const PoemEmergencyManeuvers = () => {
    return (
        <div id="040" className="">
            <p>close enough to the sun</p>
            <p>to allow for life to develop and flourish,</p>
            <p>and yet not that far from the</p>
            <p>boundary of the observable universe either.</p>
            <p>close enough to the city center,</p>
            <p>close enough to my parents' place,</p>
            <p>and yet somehow even closer to potentially</p>
            <p>complete and utter isolation.</p>
            <p>an edge of an edge,</p>
            <p>do you ever feel like you're this close to</p>
            <p>complete obliteration?</p>
            <p>i find myself holding my breath,</p>
            <p>i find parts of my body sectioned off</p>
            <p>by the edges of photographs.</p>
            <p>the balance i thought i'd fashioned</p>
            <p>is proving to be shakier than i thought.</p>
            <br />
            <p>how many things do you actually have under your control?</p>
            <p>is that even something to brag about?</p>
            <p>thorned handle,</p>
            <p>worry always takes root in between muscle fibers and</p>
            <p>on the roof of your mouth,</p>
            <p>every now and then it's unavoidable -</p>
            <p>live-threatening condition, life-saving surgery,</p>
            <p>the serum. the water. the exit.</p>
            <p>emergency recalibration,</p>
            <p>sometimes getting back on course</p>
            <p>requires</p>
            <p>removing part of the ship for good.</p>
        </div>
    );
};
